module.exports = __webpack_public_path__ + "static/media/dainik.9d8d187e.png";